import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDateStruct, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as  moment from 'moment';
import { DaytranService } from 'src/providers/daytran-ervice/daytran.service';
import { NgxSpinnerService } from 'ngx-spinner';
import FuzzySearch from 'fuzzy-search';
import { RequestByComponent } from '../request-by/request-by.component';
@Component({
  selector: 'app-void-timelog',
  templateUrl: './void-timelog.component.html',
  styleUrls: ['./void-timelog.component.scss']
})
export class VoidTimelogComponent {
  initlogs;
  logs;
  currentDate: NgbDateStruct = {
    year: Number(moment().format('YYYY')),
    month: Number(moment().format('MM')),
    day: Number(moment().format('DD'))
  };
  constructor(
    public activeModal: NgbActiveModal,
    private daytranService: DaytranService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService
  ) {
    this.initialize();
  }

  async initialize(): Promise<void> {
    this.spinner.show();
    const dateFilter = this.currentDate.year.toString() + '-' + this.currentDate.month.toString() + '-' + this.currentDate.day.toString();
    this.initlogs = await this.daytranService.getTimelogs({ date: dateFilter });
    this.logs = this.initlogs.daytran;
    await this.spinner.hide();
    console.log(this.logs);
  }

  search(event): void {
    const searcher = new FuzzySearch(this.initlogs.daytran, ['empcode', 'empno', 'fullname', 'latitude', 'longitude'], {
      caseSensitive: false
    });
    const result = searcher.search(event.target.value);
    this.logs = result;
  }

  async requestVoid(log): Promise<void> {
    const modalRef = this.modalService.open(RequestByComponent, { size: 'sm' });
    modalRef.componentInstance.log = log;
    modalRef.result.then(next => this.initialize());
  }


  filterChange() {
    this.initialize();
  }

  close() {
    this.activeModal.close();
  }

}
